import axios from "axios";

const PROXY_ENVS = Object.freeze({
    enable: "VITE_PROXY_ENABLE",
    prefix: "VITE_PROXY_PREFIX",
});

const SERVICE_ENVS = Object.freeze({
    api: "VITE_API_BASE_URL",
});

const SERVICE_DEFAULTS = Object.freeze({
    api: "https://api.suplaserai.com",
});

function readEnv(key) {
    return (import.meta && import.meta.env && import.meta.env[key]) || "";
}

function normalizeUrl(value) {
    if (!value) return "";
    const cleaned = String(value).trim().replace(/\/+$/, "");
    if (!cleaned) return "";
    if (/^[a-z][a-z\d+.-]*:\/\//i.test(cleaned) || cleaned.startsWith("/")) return cleaned;
    return `https://${cleaned.replace(/^\/+/, "")}`;
}

export function localProxyEnabled(options = {}) {
    if (!import.meta?.env?.DEV) return false;
    if (options.proxy === false) return false;
    if (options.proxy === true) return true;

    const raw = String(readEnv(PROXY_ENVS.enable) || "").toLowerCase();
    return raw === "1" || raw === "true" || raw === "yes" || raw === "on";
}

function localProxyBase(serviceKey) {
    const prefix = readEnv(PROXY_ENVS.prefix) || "/__proxy";
    const cleaned = `/${String(prefix).replace(/^\/+/, "").replace(/\/+$/, "")}`;
    return `${cleaned}/${serviceKey}`;
}

function readServiceDomain(serviceKey) {
    const envKey = SERVICE_ENVS[serviceKey];
    return normalizeUrl((envKey ? readEnv(envKey) : "") || SERVICE_DEFAULTS[serviceKey] || "");
}

export function resolveBaseURL(serviceKey = "api", options = {}) {
    if (localProxyEnabled(options) && serviceKey) return localProxyBase(serviceKey);
    const domain = options.domain ? normalizeUrl(options.domain) : readServiceDomain(serviceKey);
    return domain || "";
}

export function resolveServiceUrl(serviceKey = "api", requestPath = "", options = {}) {
    const normalizedPath = requestPath ? `/${String(requestPath).replace(/^\/+/, "")}` : "";
    return `${resolveBaseURL(serviceKey, options)}${normalizedPath}`;
}

const instance = axios.create({
    baseURL: resolveBaseURL("api"),
    withCredentials: true,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    },
});

instance.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error)
);

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        const message = error?.response?.data?.msg || error?.message || "请求失败";
        console.error("[http] request failed:", message);
        return Promise.reject(error);
    }
);

export function request(config = {}) {
    return instance.request(config);
}

export function $http(options = {}, axiosConfig = {}) {
    const serviceKey = options.serviceKey || options.service || "api";

    return axios.create(
        Object.assign(
            {
                withCredentials: true,
                baseURL: resolveBaseURL(serviceKey, options),
                headers: Object.assign({}, options.headers || {}),
            },
            axiosConfig
        )
    );
}

export const http = {
    get(url, params = {}, config = {}) {
        return instance.get(url, { params, ...config });
    },
    post(url, data = {}, config = {}) {
        return instance.post(url, data, config);
    },
    put(url, data = {}, config = {}) {
        return instance.put(url, data, config);
    },
    delete(url, config = {}) {
        return instance.delete(url, config);
    },
};

export { instance as axios };
export default instance;
